'use strict';
import FontAwesome from 'react-fontawesome';
import React from 'react';

export default class Success extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return <div className="row">
            <div className="col-md-12">
                <div className="alert alert-success">
                    <strong>
                        <FontAwesome name="check-circle" /> Password Change Completed
                    </strong>
                </div>
                <p>
                    Your password has been reset successfully and you
                    may begin using it immediately. Try logging into your
                    campus portal account at&nbsp;
                    <a href="https://myportal.fhda.edu">https://myportal.fhda.edu</a>
                </p>
            </div>
        </div>;
    }

}


// WEBPACK FOOTER //
// ./src/react/views/Success.jsx